import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const searchDate = this.props.searchDate;
    const cashCustomerData = this.props.cashCustomerData;
    const total = this.props.total;
    const month =  this.props.month;
    const selectedDatePDF = this.props.selectedDatePDF;

    return (
      <div>
        <h2><center><u>Cash Customer Details Report</u></center></h2>
        <div>&nbsp;</div>
        <h3><center> BOUGHT LEAF CASH PAYMENT FOR THE MONTH OF {month} - {selectedDatePDF.applicableYear}</center></h3>
        <div>&nbsp;</div>
        <div>
          <center>
            <h3><center>Group: {searchData.groupName}</center></h3>
            <h3><center>Factory: {searchData.factoryName}</center></h3>
            <h3>Route :{searchData.routeName === undefined ? 'All Route' : searchData.routeName}</h3>
          </center>
        </div>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer >
              <Table aria-label="caption table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Route Name</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Registration Number</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Customer Name</TableCell>
                    <TableCell align={'right'} style={{ border: "1px solid #ccc" }}>Amount(Rs)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cashCustomerData.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                        {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableRow style={{ border: "1px solid #ccc" }}>
                  <TableCell align={'left'} style={{ borderBottom: "none" }}><b>Total</b></TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderLeft: "1px solid #ccc" }}>
                    <b> {total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h4><center>*******End of List*******</center></h4>
      </div>
    );

  }

}
